import { AnyOverlay, ImageOverlay } from "../models/Post";
import { isImageOverlay } from "../lib/utils";

/** Cover-fit image with actual image content — color swatches (sourceColor)
 * render as flat color, so crop/pan is meaningless for them. */
export function isCroppableImage(overlay: AnyOverlay): overlay is ImageOverlay {
  return (
    isImageOverlay(overlay) &&
    (overlay.objectFit ?? "cover") === "cover" &&
    !overlay.sourceColor
  );
}

/**
 * Double-click crop target for a hit stack (topmost first): the selected
 * overlay when it's a croppable image (the user may have cycled to it);
 * otherwise the topmost overlay after skipping color swatches — a flat-color
 * scrim capturing the double-click used to trap users in an empty crop mode
 * over the photo they were aiming at. Double-click on text/shapes stays
 * inert, as before.
 */
export function pickCropTarget(
  stack: AnyOverlay[],
  selectedId: string | null
): ImageOverlay | null {
  const selected = selectedId
    ? stack.find((overlay) => overlay.id === selectedId)
    : undefined;
  if (selected && isCroppableImage(selected)) return selected;

  for (const candidate of stack) {
    if (isImageOverlay(candidate) && candidate.sourceColor) continue;
    return isCroppableImage(candidate) ? candidate : null;
  }
  return null;
}
